// src/features/planning/pages/MrpRunListPage.tsx
// ADR-094 Rule MRP-FE-02.
//
// ⚠️ Hook name useV1PlanningMrpRunsList inferred from ADR-082/ADR-092
// naming pattern — verify against real orval output before merging.

import { Link } from "react-router-dom";
import { useV1PlanningMrpRunsList } from "@/api/generated/v1/v1";
import type { MrpRun } from "../types";
import { extractResults } from "@/shared/utils/apiResponseUtils";
import { PageBanner } from "@/shared/components/PageBanner";

export function MrpRunListPage() {
  const { data, isLoading } = useV1PlanningMrpRunsList();
  const runs: MrpRun[] = extractResults<MrpRun>(data);

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="اجراهای برنامه‌ریزی نیاز مواد (MRP)"
        subtitle="مشاهده سوابق و خروجی‌های محاسبات نیاز مواد اولیه"
        icon="⚙️"
        helpLink="/help/planning/mrp-runs"
      />

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        {isLoading ? (
          <p className="text-muted">در حال بارگذاری...</p>
        ) : (
          <table className="w-full text-sm text-left rtl:text-right border-collapse">
            <thead>
              <tr>
                <th className="px-3 py-2.5 text-muted font-medium border-b border-white/10">تاریخ اجرا</th>
                <th className="px-3 py-2.5 text-muted font-medium border-b border-white/10">تعداد نیازها</th>
                <th className="px-3 py-2.5 text-muted font-medium border-b border-white/10"></th>
              </tr>
            </thead>
            <tbody>
              {runs.map((run) => (
                <tr key={run.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                  <td className="px-3 py-2.5">{new Date(run.executed_at).toLocaleString("fa-IR")}</td>
                  <td className="px-3 py-2.5">{run.requirement_count}</td>
                  <td className="px-3 py-2.5">
                    <Link to={`/planning/mrp-runs/${run.id}`} className="text-primary-500 hover:underline">مشاهده</Link>
                  </td>
                </tr>
              ))}
              {runs.length === 0 && (
                <tr>
                  <td colSpan={3} className="px-3 py-8 text-center text-muted">
                    هنوز هیچ اجرای MRP‌ای ثبت نشده است.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
